export default "__VITE_ASSET__QUl6QeEX__"